export const GET_AB_TEST_DETAILS = 'GET_AB_TEST_DETAILS';
export const AB_TEST_DETAILS_SUCCESS = 'AB_TEST_DETAILS_SUCCESS';
